/**
 * Página de Erro 404 - Não encontrado
 * Fidelidade visual pixel-perfect com o original Rails
 */
import { useTranslation } from 'react-i18next';

export function Error404Page() {
  const { t } = useTranslation();
  return (
    <div className="text-center w-full mt-[100px]">
      <div className="text-[68px]">{t('views.errors.oops', 'Ops!')}</div>
      <div className="text-[22px]">
        {t('views.errors.not_found', 'Não conseguimos localizar a página desejada :(')}
      </div>
    </div>
  );
}
